import React, { PureComponent } from 'react';
import { Translate } from 'react-redux-i18n';
import moment from 'moment-timezone';

import StringUtil from '../../app/utils/string';

class AdminUsersImportErrors extends PureComponent {
  
  render() {
    const { errors = [] } = this.props;


    if (!errors.length) {
      return null;
    };

    return (
      <div className="items-errors">
        <hr />

        <h5><Translate value="dragAndDropAdminUsersErrorTitle" /></h5>

        {errors.map(error => (
          <React.Fragment key={error.code}>
            <p>
              <Translate value="code" />
              {': '}
              <b>{error.code}</b>

              {' - '}
              <Translate value="line" />
              {' '}
              {error.line}
              {': '}

              {error.types.map((type, index) => (
                <React.Fragment>
                  <Translate value={`dragAndDropAdminUsersError${StringUtil.capitalizeFirstLetter(type)}`} />
                  {index !== error.types.length - 1 ? ', ' : ''} 
                </React.Fragment>
              ))}
            </p>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default AdminUsersImportErrors;
